<template>
  <div class="content">
    <img v-show="$i18n.locale==='zh'" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title.png"  class='img-title'>
    <img v-show="$i18n.locale==='en'" :src="home_title_en"  class='img-title-en'>
    <el-row v-if="$i18n.locale==='zh'" style="margin-top:3vw">
      <el-col :lg="24">
        <div class='home_content'>
          <div class='home_title'>
            <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
            <p>{{$t('home.bole_we')}}</p>
          </div>
          <el-carousel :interval="1500" type="card" :width="clientHeight" :autoplay="true" class="carou-height hidden-sm-and-down">
            <el-carousel-item v-for="item in bole_images" :key="item.name" :style="item.style">
              <div class="photo-title"><span class="photo-span">2019·年会</span></div>
            </el-carousel-item>
          </el-carousel>
          <el-carousel :interval="1500" type="card" :height="clientHeight2" :autoplay="true" class="carou-height hidden-md-and-up">
            <el-carousel-item v-for="item in bole_images" :key="item.name" :style="item.style">
              <div class="photo-title"><span class="photo-span">2019·年会</span></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>

      <el-col :lg="24">
        <div class='home_content'>
          <div class='home_title'>
            <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
            <p>{{$t('home.bole_we')}}</p>
          </div>
          <div class="video_content">
            <div class="video">
              <video v-if="is_mobile_video" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/bole_video_v3.mp4"  preload="none"
                     controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_1.jpg"> </video>
              <video v-else src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/bole_video_mobile.mp4"  preload="none"
                     controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_1.jpg"> </video>
            </div>
          </div>
        </div>
      </el-col>

    </el-row>
    <el-row v-else class="content-en-mobile">
      <el-col :lg="24">
        <div class='home_content'>
<!--          <div class="video_content">-->
<!--            <div class="video">-->
<!--              <video src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/home_bole_mobile.mp4"  preload="none"-->
<!--                     controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_3.jpg"> </video>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  export default {

    data() {
      return {
        all_news: [],
        clientHeight: `${document.documentElement.clientWidth * (4016 / 6016)}px`,
        clientHeight2: `${document.documentElement.clientWidth * (545 / 1920)}px`,

        bole_images: [
          {
            name: 'phpto1',
            style: {
              backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/photo_1.jpg')`,
              backgroundSize: '100% ',
              'background-repeat': 'no-repeat',
              backgroundColor: '#0a0726',
            },
          },
          {
            name: 'phpto2',
            style: {
              backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/photo_2.jpg')`,
              backgroundSize: '100% ',
              'background-repeat': 'no-repeat',
              backgroundColor: '#0a0726',
            },
          },
           {
            name: 'phpto3',
            style: {
              backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/photo_3.jpg')`,
              backgroundSize: '100% ',
              'background-repeat': 'no-repeat',
              backgroundColor: '#0a0726',

            },
          },
        ]
      };
    },

    mounted() {
      const that = this;
      window.onresize = function temp() {
        that.clientWidth = `${document.documentElement.clientHeight}px`;
      };
    },
    methods: {
      // test() {
      //   const jsonUrl = './api/upload_emails';
      //   this.axios.get(jsonUrl)
      //     .then((res) => {
      //       console.log(res)
      //     });
      // }
    },
    computed: {
      //是否使用移动端视频
      is_mobile_video() {
        return document.documentElement.clientWidth > 992;
      },
      home_title_en() {
        return document.documentElement.clientWidth > 992 ? 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_en.png' : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_en_mobile.png';
      }
    },
  };
</script>

<style lang='less'>
  /*@import 'element-ui/lib/theme-chalk/display.css';*/
  @import url('../assets/style/common.less');
  @import url('../assets/style/colors.less');
  .content{
    width: 100%;
    margin: 0 auto;
    padding-top: 3%;
  }
  .content-en-mobile {
    display: none;
  }
  .img-title {
    height: 4.5vw;
    margin-bottom:0.5vw
  }
  .img-title-en {
    height: 7.5vw;
    margin-bottom:0.5vw
  }
  .home-title-icon {
    height: 4.5vw;
  }
  .photo-title {
    position: absolute;
    width: 100%;
    bottom: 0;
    background: @lanmu;
    height: 45px;
    font-size: 18px;
    line-height: 43px;
    color: #f3c258;
    border-bottom: 4px solid #f3c258;
    span.photo-span {
      border-bottom: 1px solid;
    }
  }
  .carou-height{
    overflow: hidden;
  }
  @media screen and (max-width: 992px) {
    .content-en-mobile {
      display: block;
      margin: 5vw 0 10vw 0;
    }
    .img-title {
      height: 5.5vw;
      margin-bottom:0.5vw;
    }
    //.img-title-en {
    //  height: 11.5vw;
    //  margin-top: 31vw;
    //  margin-bottom: 14.5vw;
    //}
    .img-title-en {
      height: 11.5vw;
      margin-top: 6vw;
      margin-bottom: -9.5vw;
    }
    .home-title-icon {
      height: 6.5vw;
    }
    .photo-title {
      height: 32px;
      font-size: 14px;
      line-height: 30px;
      color: #f3c258;
      border-bottom: 3px solid #f3c258;
      span.photo-span {
        border-bottom: 1px solid;
      }
    }
  }





  //给轮播图选项页增加固定高度，避免抖动
  .el-carousel__indicators--outside {
      height: 4vw;
  }
  .news {
    list-style-type: None;

    .image {
      width: 100%;
      display: block;
    }
    a {
      text-decoration: none;
    }
    .content {
      width: 100%;
      height: 100px;
      background-size: cover;
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>




// WEBPACK FOOTER //
// src/components/Content.vue